import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage

import themeSlice from "./slice/themeSlice";
import authSlice from "./slice/authSlice";
import querySlice from "./slice/querySlice";

const rootReducer = combineReducers({
    theme: themeSlice,
    auth: authSlice,
    query: querySlice,
});

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["auth", "query", "theme"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);
